import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '../../ui/Alert';
export function InvalidPDFs({ invalidPDFs }) {
    const { t } = useTranslation();
    if (!invalidPDFs || invalidPDFs.length === 0) {
        return null;
    }
    return ((React.createElement("div", { "data-testid": "div-ea72a8e6" },
        React.createElement(Alert, { dataTestId: "Alert-8c197e5e", type: "error" },
            React.createElement("p", { "data-testid": "p-6f2825cf", className: "font-semibold mb-2" }, t('FOLLOWING_PDF_COULD_NOT_BE_UPLOADED')),
            React.createElement("ul", { "data-testid": "ul-f78980d0" }, invalidPDFs.map((pdf, index) => (React.createElement("li", { "data-testid": `li-ca0c5bab-${index}`, key: pdf }, pdf))))))));
}
